"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Component = _interopRequireDefault(require("../Component"));

var _Button = _interopRequireDefault(require("../Button"));

var _ButtonSegment = _interopRequireDefault(require("./ButtonSegment"));

var _globals = require("../../../globals");

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var ButtonSegmentGroup =
/** @class */
function (_super) {
  __extends(ButtonSegmentGroup, _super);

  function ButtonSegmentGroup(opts) {
    var _this = _super.call(this, (0, _utils.extend)({
      reloadOnChange: true
    }, opts, {
      ui: {
        segments: '.awxjs__ui-btn-segments ul'
      }
    })) || this;

    _this.storedSegments = [];
    return _this;
  }

  Object.defineProperty(ButtonSegmentGroup.prototype, "id", {
    get: function () {
      return this.opts.id;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegmentGroup.prototype, "title", {
    get: function () {
      return this.opts.title;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegmentGroup.prototype, "value", {
    get: function () {
      var selected = this.selectedSegments();

      if (this.opts.filter === true) {
        return {
          id: this.id,
          filters: selected.map(function (segment) {
            return segment.value;
          }).join(';'),
          parent: this.id
        };
      }

      return {
        segments: selected.map(function (segment) {
          return {
            id: segment.id,
            value: segment.value,
            group: segment.groupId,
            parent: segment.parentId,
            options: segment.options
          };
        })
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ButtonSegmentGroup.prototype, "segments", {
    get: function () {
      return this.storedSegments;
    },
    enumerable: false,
    configurable: true
  });

  ButtonSegmentGroup.prototype.setSegments = function (segments) {
    var _this = this;

    this.storedSegments = segments;

    if (this.ui.segments) {
      segments.forEach(function (segment) {
        segment.addTo(_this.ui.segments);
        segment.on(_Button.default.Event.SELECT, function (e) {
          _this._handleSelectSegment(segment);
        }).on(_Button.default.Event.DESELECT, function (e) {
          _this._handleDeselectSegment(segment);
        });
      });
    }
  };

  ButtonSegmentGroup.prototype.selectedSegments = function () {
    return this.segments.filter(function (segment) {
      return segment.selected;
    });
  };

  ButtonSegmentGroup.prototype.clear = function () {
    this.selectedSegments().forEach(function (item) {
      item.deselect();
    });
  };

  ButtonSegmentGroup.prototype._handleSelectSegment = function (segment) {
    var allowMultiselect = this.opts.multiselect && segment.value !== 'all' && segment.multiselect !== false;

    if (allowMultiselect === false) {
      this.selectedSegments().forEach(function (item) {
        if (item.value !== segment.value) {
          item.deselect();
        }
      });
    } else {
      // deselect all segments that don't support multiselect
      this.selectedSegments().forEach(function (item) {
        if (item.multiselect === false) {
          item.deselect();
        }
      });
    }

    this._handleValueChange();
  };

  ButtonSegmentGroup.prototype._handleDeselectSegment = function (segment) {
    // if no selection and we have non-multiselect options (or 'all'), then select
    // that one instead by default or the first one if no 'all' option
    if (this.selectedSegments().length === 0) {
      if (this.opts.multiselect) {
        var selectedSegment_1;
        this.segments.forEach(function (item) {
          if (!selectedSegment_1 && (item.value === 'all' || item.multiselect === false)) {
            item.select();
            selectedSegment_1 = item;
          }
        });
      } else {
        this.segments[0].select();
      }
    }

    this._handleValueChange();
  };

  ButtonSegmentGroup.prototype._handleValueChange = function () {
    // const previousValue = { ...this._value };
    // const value = this.value;
    // this.trigger('value:change', { value, previous: previousValue });
    // this._value = { ...value };
    this.trigger('change', {
      id: this.id,
      selected: this.selectedSegments().map(function (item) {
        return item.id;
      }),
      reload: this.opts.reloadOnChange
    });
  };

  ButtonSegmentGroup.prototype._render = function (data) {
    return "\n\t\t\t<div data-group=\"" + this.id + "\" class=\"" + _globals.Globals.cssPrefix + "ui-btn-segmented__group\">\n\t\t\t\t" + (!(0, _utils.isEmpty)(this.title) ? "<p class=\"" + _globals.Globals.cssPrefix + "ui-btn-segmented__group-title\">" + this.title + "</p>" : '') + "\n\t\t\t\t<div class=\"" + _globals.Globals.cssPrefix + "ui-btn-segments\"><ul></ul></div>\n\t\t\t</div>\n\t\t";
  };

  ButtonSegmentGroup.prototype._onAddedToDOM = function () {
    var _this = this;

    _super.prototype._onAddedToDOM.call(this);

    var segments = this.opts.segments;
    var result = (segments || []).map(function (config) {
      var valueKey = config.value.replace(/\:.+$/, '').replace(/,/, '--').replace(/;/, '__');
      config.id = config.id || _this.id + "-" + valueKey;
      return new _ButtonSegment.default(__assign(__assign({}, config), {
        loader: false,
        toggleable: _this.opts.multiselect === true,
        parent: _this.id
      }));
    });
    this.setSegments(result);
  };

  return ButtonSegmentGroup;
}(_Component.default);

var _default = ButtonSegmentGroup;
exports.default = _default;
module.exports = exports.default;